import { createContext, useState } from 'react'

const loginSteps = {
  GETPHONENUMBER: 'GETPHONENUMBER',
  GETVERIFICATIONCODE: 'GETVERIFICATIONCODE',
  GETINFORMATION: 'GETINFORMATION',
  SHOWHOSTPANELCTA: 'SHOWHOSTPANELCTA',
}

interface LoginProviderProps {
  children: React.ReactNode
  loginCallback: (args: { isHost: boolean }) => void
  onClose?: () => void
}

export interface LoginContext {
  step: keyof typeof loginSteps
  phoneNumberDefault: string
  otpDefault: string
  handleChangeStep: (nextStep: keyof typeof loginSteps) => void
  handleSetPhoneNumber: (mobile: string) => void
  handleSetOTP: (otp: string) => void
  loginCallback: (args: { isHost: boolean }) => void
  onClose?: () => void
}

export const LoginContext = createContext<LoginContext | null>(null)

const LoginProvider: React.FC<LoginProviderProps> = ({
  children,
  loginCallback,
  onClose,
}) => {
  const [step, setStep] = useState<keyof typeof loginSteps>(
    loginSteps.GETPHONENUMBER as keyof typeof loginSteps,
  )
  const [phoneNumberDefault, setPhoneNumberDefault] = useState('')
  const [otpDefault, setOtpDefault] = useState('')

  const handleChangeStep = (nextStep: keyof typeof loginSteps) => {
    if (nextStep !== step) {
      setStep(nextStep)
    }
  }

  const handleSetPhoneNumber = (mobile: string) => {
    if (mobile.trim()) {
      setPhoneNumberDefault(mobile)
    }
  }

  const handleSetOTP = (otp: string) => {
    setOtpDefault(otp)
  }

  return (
    <LoginContext.Provider
      value={{
        step,
        phoneNumberDefault,
        handleChangeStep,
        handleSetPhoneNumber,
        otpDefault,
        handleSetOTP,
        loginCallback,
        onClose,
      }}
    >
      {children}
    </LoginContext.Provider>
  )
}

export default LoginProvider
